// Agency configuration - determines if site is locked to specific agency
export const getAgencyConfig = () => {
  // Check URL path for agency-specific deployment
  const pathname = window.location.pathname;
  const hostname = window.location.hostname;
  
  // Check for agency-specific subdomain or path
  // Examples: 
  //   https://virginia.vulcan-tech.com/doe
  //   https://doe.virginia.vulcan-tech.com
  //   https://virginia-doe.netlify.app
  
  // Extract agency from path (e.g., /doe, /DOE, /treasury, /vdh) - case insensitive
  const pathMatch = pathname.toLowerCase().match(/^\/([a-z]+)\/?$/);
  if (pathMatch) {
    const agency = pathMatch[1].toLowerCase();
    const validAgencies = ['treasury', 'doe', 'vdh', 'dmme', 'deq', 'dcjs', 'dbhds', 'dss', 'vdacs', 'dmas', 'dpor', 'ferc', 'cea'];
    
    if (validAgencies.includes(agency)) {
      console.log('🔒 Agency locked to:', agency);
      return {
        locked: true,
        agency: agency,
        displayName: getAgencyDisplayName(agency)
      };
    }
  }
  
  // Check for agency-specific subdomain
  const subdomainMatch = hostname.match(/^([a-z]+)\./);
  if (subdomainMatch && subdomainMatch[1] !== 'virginia' && subdomainMatch[1] !== 'www') {
    // Special case for cea.vulcan-tech.com - maps to FERC
    if (subdomainMatch[1] === 'cea') {
      return {
        locked: true,
        agency: 'cea',
        displayName: 'Federal Energy Regulatory Commission'
      };
    }
    return {
      locked: true,
      agency: subdomainMatch[1],
      displayName: getAgencyDisplayName(subdomainMatch[1])
    };
  }
  
  // Check for environment variable (set during build)
  const lockedAgency = import.meta.env.VITE_LOCKED_AGENCY;
  if (lockedAgency) {
    return {
      locked: true,
      agency: lockedAgency,
      displayName: getAgencyDisplayName(lockedAgency)
    };
  }
  
  // Not locked - main site with all agencies
  return {
    locked: false,
    agency: null,
    displayName: null
  };
};

const getAgencyDisplayName = (agencyCode) => {
  const names = {
    'treasury': 'Department of the Treasury',
    'doe': 'Department of Education',
    'vdh': 'Department of Health',
    'dmme': 'Department of Mines, Minerals and Energy',
    'deq': 'Department of Environmental Quality',
    'dcjs': 'Department of Criminal Justice Services',
    'dbhds': 'Department of Behavioral Health',
    'dss': 'Department of Social Services',
    'vdacs': 'Department of Agriculture',
    'dmas': 'Department of Medical Assistance Services',
    'dpor': 'Department of Professional and Occupational Regulation',
    'ferc': 'Federal Energy Regulatory Commission',
    'cea': 'Federal Energy Regulatory Commission'
  };
  
  return names[agencyCode] || agencyCode.toUpperCase();
};

export default getAgencyConfig;